import { Compass, Target, TrendingUp, Globe, Users, Crosshair, ShieldCheck } from "lucide-react";
import Reveal from "@/components/Reveal";
import { OUTCOMES } from "@/content";

const ICONS = { Compass, Target, TrendingUp, Globe, Users, Crosshair, ShieldCheck };

export default function OutcomesGrid() {
  return (
    <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-12" data-testid="outcomes-grid">
      {OUTCOMES.map((o, i) => {
        const Icon = ICONS[o.icon];
        return (
          <Reveal key={o.id} delay={i * 0.05} className={`h-full ${i < 3 ? "lg:col-span-4" : "lg:col-span-3"}`}>
            <div
              className="group flex h-full flex-col gap-5 bg-navy p-7 transition-colors duration-300 hover:bg-navy-light/60"
              data-testid={`outcome-card-${o.id}`}
            >
              <span className="flex h-9 w-9 items-center justify-center border border-gold/40 text-gold transition-colors duration-300 group-hover:border-gold" aria-hidden="true">
                <Icon size={16} strokeWidth={1.75} />
              </span>
              <h3 className="font-display text-lg font-bold tracking-[-0.03em] leading-snug text-white">{o.title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{o.body}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
}
